import React, { useState, useEffect } from "react"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import "./body-consulting.scss"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import text from "../../../assets/images/sexologaRecurso.svg"
const BodyConsulting = props => {
  const { mobile, params } = props
  var contentInfo = params.consultorios
  const [contentInfoList, setContentInfoList] = useState([])
  const [isShowSexologist, setIsShowSexologist] = useState(false)
  const [isShowLoving, setIsShowLoving] = useState(true)
  const [slidesToShow, setSlidesToShow] = useState(2)

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem("USER_INFO")).birthdate.replace(/ /g, "T")
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  var settings1 = {
    infinite: true,
    slidesToShow: mobile ? 1 : 3,
    dots: mobile ? true : false,
    slidesToScroll: 1,
    arrows: false,
  }

  var settings2 = {
    infinite: true,
    slidesToShow: mobile ? 1 : slidesToShow,
    dots: !!mobile,
    slidesToScroll: 1,
    arrows: mobile ? true : false,
    customPaging: i => {
      let color = ""
      if (contentInfoList && contentInfoList[i].titulo === "Ginecóloga") {
        color = "purple"
      } else if (contentInfoList && contentInfoList[i].titulo === "Sexóloga") {
        color = "pink"
      } else if (contentInfoList && contentInfoList[i].titulo === "Bullying") {
        color = "black"
      } else {
        color = "blue"
      }
      return (
        <div className={`nav-button ${color}`}>
          {contentInfoList && contentInfoList[i].titulo}
        </div>
      )
    },
  }

  const dataLayerConsulting = (url) => {
    const homeLink = siteUrl
    pushDataLayerEvent({
      event: "cta_click",
      link_text: "Consultar",
      link_url: homeLink+url,
      link_domain: window.location.hostname.split('www.')[0],
      link_id: "",
      link_classes: ""
    })
  }

  useEffect(() => {
    if (
      process.env.LOCALE === "es-CO" &&
      localStorage.getItem("TOKEN_INFO") &&
      localStorage.getItem("USER_INFO") &&
      calculateAge() >= 18
    ) {
      setIsShowSexologist(true)
    }
  }, [])

  useEffect(() => {
    let newContenInfoList
    if (isShowSexologist) {
      newContenInfoList = [...contentInfo]
    } else {
      newContenInfoList = contentInfo.filter(item => {
        return item.titulo !== "Sexóloga"
      })
    }
    setSlidesToShow(newContenInfoList.length > 2 ? 3 : 2)
    setContentInfoList([...newContenInfoList])
  }, [isShowSexologist])


  return (
    <div className="f-body-consulting">
      <Slider className="f-top-info-container" {...settings1}>
        <div>
          <div className="f-box f-left-box">
            <span className="f-cicle-container">
              <span className="icon-anonymous" />
            </span>
            <div className="f-text-box-container">
              <p className="f-text">
                Tu consulta es anónima.{" "}
                <b>
                  {process.env.LOCALE === "es-PY" ? "Preguntá" : "Pregunta"} con
                  seguridad.
                </b>
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="f-box f-center-box">
            <span className="f-cicle-container">
              <span className="icon-email" />
            </span>
            <div className="f-text-box-container">
              <p className="f-text">
                <b>Tu respuesta es personalizada</b> y la{" "}
                {process.env.LOCALE === "es-PY" ? "recibís" : "recibes"} en tu
                correo.
              </p>
            </div>
          </div>
        </div>
        <div>
          <div className="f-box f-right-box">
            <span className="f-cicle-container">
              <span className="icon2-free" />
            </span>
            <div className="f-text-box-container">
              <p className="f-text">
                <b>¡Es gratis!</b>{" "}
                {process.env.LOCALE === "es-PY" ? "Podés" : "Puedes"} consultar
                las veces que quieras.
              </p>
            </div>
          </div>
        </div>
      </Slider>

      <Slider className="f-cards-container" {...settings2}>
        {contentInfoList.map((consultorio, index) => {
          var color = ""

          if (consultorio.titulo === "Ginecóloga") {
            color = "purple"
          } else if (consultorio.titulo === "Sexóloga") {
            color = "pink"
          } else if (consultorio.titulo === "Bullying") {
            color = "black"
          } else {
            color = "blue"
          }
          return (
            <a
              className="f-consulting-card-container"
              href={"/entre-nosotras/consultorios/" + consultorio.slug}
              key={index}
              onClick={()=>{dataLayerConsulting("/entre-nosotras/consultorios/" + consultorio.slug)}}
            >
              <div
                className={`f-consulting-card ${
                  consultorio.titulo === "Sexóloga"
                    ? "bold"
                    : consultorio.titulo === "Bullying"
                    ? "dark"
                    : ""
                }`}
              >
                {consultorio.titulo === "Bullying" && (
                  <div className="new-advice">
                    <span>NUEVO</span>
                  </div>
                )}
                <div
                  className={
                    consultorio.titulo === "Bullying"
                      ? "f-cicle-container " + color + " bordered"
                      : "f-cicle-container " + color
                  }
                >
                  <img
                    className="f-consulting-prev-img"
                    src={consultorio.imagenMiniatura.file.url}
                    alt={consultorio.imagenMiniatura.description}
                  />
                </div>
                <span className="fake-element"></span>
                <label
                  className={
                    consultorio.titulo === "Bullying"
                      ? "f-card-title-loving dark-pink-title"
                      : "f-card-title " + color + "-title"
                  }
                >
                  {consultorio.titulo}
                </label>
                <p
                  className={
                    consultorio.titulo === "Bullying"
                      ? "f-card-description white-title"
                      : "f-card-description"
                  }
                  dangerouslySetInnerHTML={{
                    __html:
                      consultorio.descripcionDelConsultorio
                        .descripcionDelConsultorio,
                  }}
                ></p>
                {consultorio.titulo === "Sexóloga" && (
                  <img
                    className="f-img-item-text"
                    src={text}
                    alt="tu consulta es completamente privada."
                  />
                )}
                {/* <Link to={'/' + consultorio.slug}> */}
                <div
                  className={
                    consultorio.titulo === "Bullying"
                      ? "f-fake-button dark-pink"
                      : "f-fake-button " + color
                  }
                >
                  Consultar
                </div>
                {/* </Link> */}
              </div>
            </a>
          )
        })}
      </Slider>
    </div>
  )
}

export default BodyConsulting
